<template>
  <div class="user-mg">
    <el-breadcrumb class="admin-path" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>系统管理</el-breadcrumb-item>
      <el-breadcrumb-item>用户管理</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="container">
      <el-form :inline="true" :model="searchParams" class="search-form">
        <el-form-item label="姓名">
          <el-input v-model="searchParams.name"></el-input>
        </el-form-item>

        <el-form-item label="邮箱">
          <el-input v-model="searchParams.useremail"  style="width: 200px"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onSubmit">Search</el-button>
        </el-form-item>
      </el-form>

      <el-table
        :data="list"
        style="width: 100%">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          prop="id"
          label="ID"
          v-if="false">
        </el-table-column>
        <el-table-column
          prop="umtId"
          label="高能所用户ID">
        </el-table-column>
        <el-table-column
          prop="truename"
          label="姓名">
        </el-table-column>
        <el-table-column
          prop="cstnetId"
          label="cst网ID">
        </el-table-column>
        <el-table-column
          prop="passwordType"
          label="密码类别"
           v-if="false">
        </el-table-column>
        <el-table-column
          prop="cstnetIdStatus"
          label="cst网ID状态">
        </el-table-column>
        <el-table-column
          prop="type"
          label="类型">
        </el-table-column>
        <el-table-column
          prop="useremail"
          label="用户邮件地址">
        </el-table-column>
        <el-table-column
          prop="isadmin"
          label="是否管理员"
          align="center"
          width="60">
        </el-table-column>
        <el-table-column
          prop="userphone"
          label="用户电话">
        </el-table-column>
        <el-table-column
          prop="usercp"
          label="用户单位">
        </el-table-column>
        <el-table-column
          prop="userposition"
          label="用户职位">
        </el-table-column>

        <el-table-column
          width="100"
          label="操作">
          <template slot-scope="scope">
            <el-button
              class="copy-btn"
              :data-clipboard-text="scope.row"
              type="text"
              size="small"
              @click="usermgEdit(scope.row)">
              编辑
            </el-button>
            <!-- <el-button
              class="copy-btn"
              :data-clipboard-text="scope.row.id"
              type="text"
              size="small"
              @click="usermgDelete(scope.row.id)">
              删除
            </el-button>              -->
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="currentPage"
        :page-size.sync="pageSize"
        :total="total"
        @size-change="sizeChange"
        @current-change="changePage">
      </el-pagination>
      
      <UserMgEditDialog
        :dialog-visible="UserMgEditIsVisible"
        :dialog-data="currentDataId"
        @ok="confirmUserMgEditDialog"
        @close="closeUserMgEditDialog">
      </UserMgEditDialog>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import UserMgEditDialog from './UserMgEditDialog.vue';
export default {
  name: 'UserMg',
  components: {
    UserMgEditDialog,
  },
  data() {
    return {
      searchParams: {
        grbid: '',
        startTime: '',
        endTime: '',
      },
      list: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      currentDataId:null,
      UserMgEditIsVisible:false,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      const params = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        ...this.searchParams,
      }
      axios.post('/iapi/UserMg', params).then((res) => {
        if (res.data.errcode === 0) {
          this.total = res.data.data.total;
          this.list = res.data.data.list;
        }
      });
    },
    changePage(page) {
      this.currentPage = page;
      this.getData();
    },
    onSubmit() {
      this.currentPage = 1;
      this.getData();
    },
    sizeChange() {
      this.getData();
    },
    
    usermgDelete(DataID){
      const params = {
        data_id: DataID,
      };
      axios.post('/iapi/usermgdelete', params).then((res) => {
        if (res.data.errcode === 0) {
          this.$message('删除用户信息成功！');
        }
      });
      this.getData();
    },
    usermgEdit(dataId){
      this.UserMgEditIsVisible = true;
      this.currentDataId = dataId;
    },
    closeUserMgEditDialog(){
      this.UserMgEditIsVisible = false;
    },
    confirmUserMgEditDialog(data){
      this.closeUserMgEditDialog();
      const params = {
        id : data.id,
        umtId : data.umtId,
        truename : data.truename,
        cstnetId : data.cstnetId,
        type : data.type,
        passwordType : data.passwordType,
        cstnetIdStatus : data.cstnetIdStatus,
        useremail : data.useremail,
        isadmin : data.isadmin,
        userphone : data.userphone,
        usercp : data.usercp,
        userposition : data.userposition,
        tutorname : data.tutorname,
        tutoremail : data.tutoremail,
        create_date : data.create_date,
        update_date : data.update_date,
        remarks : data.remarks,
        del_flag : data.del_flag,       
      }
      axios.post('/iapi/usermgedit', params).then((res) => {
        if (res.data.errcode === 0) {
          this.$message('编辑用户信息成功！');
        }
      });
      this.getData();  
    },
  },
};
</script>

<style scoped>
.user-mg {
  padding: 24px 56px;
}
.container {
  background: #fff;
  border-radius: 2px;
}
.search-form {
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 8px;
  padding-bottom: 8px;
}
.el-form-item {
    color: blue;
    margin-top: 0px;
    margin-bottom: 0px;
}
.admin-path {
  margin-bottom: 16px;
}
</style>